import 'reflect-metadata';
import '../fix';
import { createApp } from 'vue';
import ShareApp from './ShareApp.vue';
import { shareRouter } from './share-router';
import { i18n, loadI18n } from '@/infrastructure/locales'
import { setContainer } from '@patsnap/tahiti-core/ioc/inject';
import { Container, ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { ShareApiService, ShareApiServiceImpl } from './share-api-service';
import psHttp, { psHttp$ } from '@patsnap/common-ps-http';
import { PsHttp } from '@patsnap/tahiti-core/common/ps-http';
import { PsHttp$, PsHttpChannel, PsHttpChannelImpl } from '@patsnap/tahiti-core/common/http-channel';
import { shareModule } from '@eureka/shared/share-tools/logic';
import { biTrackModule } from '@eureka/domains';
import { GtmPlugin } from '@eureka/shared/gtm';

const container = new Container({
    defaultScope: 'Singleton',
    skipBaseClassChecks: true,
});
container.load(
    new ContainerModule((bind) => {
        bind(PsHttp).toConstantValue(psHttp);
        bind(PsHttpChannel).to(PsHttpChannelImpl);
        bind(PsHttp$).toConstantValue(psHttp$);
        bind(ShareApiService).to(ShareApiServiceImpl);
    }),
    shareModule,
    biTrackModule
);

setContainer(container);

(async() => {
    await loadI18n();
    createApp(ShareApp).use(shareRouter).use(GtmPlugin, shareRouter).use(i18n).mount('#app');
})()
